import send from "../../util/request";

export function getAddressList(params={}) {
  return send({ url: '/ipp/user-address/select', method: 'GET' ,params});
}